export default {
  fontFamily: ['Fira Sans', '"Segoe UI Symbol"'].join(','),
};
